import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-203a63be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "email-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "top-container" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Wil je de poster per e-mail ontvangen?"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Vul dan je e-mailadres in.")
  ])
], -1))
const _hoisted_3 = { id: "email-input" }
const _hoisted_4 = { id: "keyboard-container" }
const _hoisted_5 = { id: "actions" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "container-opt-in" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("Je e-mailadres wordt alleen gebruikt voor"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("het versturen van een mail met je verkiezingsposter.")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_top_header = _resolveComponent("top-header")!
  const _component_simple_keyboard = _resolveComponent("simple-keyboard")!
  const _component_submit_button = _resolveComponent("submit-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_top_header),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input) = $event)),
        type: "email",
        placeholder: "e-mail adres",
        class: _normalizeClass({invalid: _ctx.invalidEmail})
      }, null, 2), [
        [_vModelText, _ctx.input]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_simple_keyboard, {
        modelValue: _ctx.input,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.input) = $event))
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_submit_button, {
        id: "start-button",
        onClick: _ctx.submit,
        disabled: !_ctx.input
      }, {
        default: _withCtx(() => [
          _createTextVNode("OK")
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    _hoisted_6
  ]))
}